import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentFilters, ContentTopBar } from 'components';
import {
    MainFilters,
    MainFiltersParams,
} from 'components/main-filters/main-filters';
import {
    EventsFilterFormValues,
} from 'features/events';
import { usePermissions } from 'features/users';
import { usePaginationParams } from 'hooks';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { AreaFilterForm, AreaFilterFormPaginated, AreaFilterFormValues } from '../components/area-filter-form';
import { AreaTable } from '../components/manage-area';
import { AddAreaModal } from '../components/manage-area/add-area-modal/add-area-modal';
import { useGetArea } from '../use-cases/get-area';

const { useBreakpoint } = Grid;

const initialFilterValues: AreaFilterFormValues = {
    name: undefined,
    is_active: undefined

};

export const ManageAreaView = () => {
    const screens = useBreakpoint();
    const permissions = usePermissions();
    const { params, updateParams, resetPage } =
        usePaginationParams<AreaFilterFormPaginated>({
            page: 1,
            size: 10,
            order_by: '-rank',
            ...initialFilterValues,
        });

    const { data, isFetching, refetch } = useGetArea(params as any, { retry: false });
    const [areaEditData, setAreaEditData] = useState<any>(undefined);

    const shouldHandleFieldCreation = permissions?.fields.add;

    const handleFiltersChange = (values: EventsFilterFormValues) => {
        updateParams(values);
        resetPage();
        refetch();
    };

    const handleMainFiltersChange = (mainParams: MainFiltersParams) => {
        updateParams(mainParams);
        resetPage();
    };
    const [showAreaModal, setShowAreaModal] = useState(false);
    const formId = 'events-filters-form';

    const handleCloseModal = () => {
        setShowAreaModal(false);
        document.body.style.overflow = 'visible';
    }

    const handleOpenModal = () => {
        setShowAreaModal(true);
        document.body.style.overflow = 'hidden';
    }

    return (
        <>
            <ContentTopBar
                title={"Manage Area"}
                renderHeadingContent={
                    <MainFilters onChange={handleMainFiltersChange} />
                }
                renderButtons={
                    <>
                        {shouldHandleFieldCreation ? (
                            <>
                                <Button
                                    icon={!screens.xs ? <PlusOutlined /> : undefined}
                                    type='primary'
                                    onClick={handleOpenModal}
                                >
                                    {"Add Manage Area"}
                                </Button>
                                <div className={`cstmrightmdl ${showAreaModal && "show"}`}>
                                    <AddAreaModal showAreaModal={showAreaModal} refetch={refetch} onClose={handleCloseModal} areaEditData={areaEditData} />

                                </div>

                            </>
                        ) : null}
                    </>
                }
            />

            <ContentFilters formId={formId}>
                <AreaFilterForm
                    formId={formId}
                    handleFilter={handleFiltersChange as any}
                    initialValues={initialFilterValues as any}
                />
            </ContentFilters>
            <AreaTable
                data={data}
                isLoading={isFetching}
                tableParams={params}
                updateParams={updateParams}
                refetch={refetch}
                areaEditData={areaEditData}
                setAreaEditData={setAreaEditData}
            />
            <Outlet />
        </>
    );
};



